<template>
  <b-col
    cols="12"
    :sm="colSize"
    class="mb-4"
  >
    <div
      v-if="!event.published"
      class="draft-badge"
    >
      <h5>
        <b-badge variant="warning">
          下書き
        </b-badge>
      </h5>
    </div>
    <article
      class="card"
    >
      <b-link
        :to="{name: 'event-detail', params: {id: event.id}}"
        class="no-hover"
      >
        <img
          :src="getImage(event)"
          :alt="event.title"
          class="card-img-top event-thumbnail"
        >
        <div class="card-body">
          <span class="date">
            <b-icon icon="calendar2-event" />
            {{ getDate(event.date) }}
          </span>
          <h5 class="card-title">
            {{ event.title }}
          </h5>
          <p class="card-text address">
            <b-icon
              icon="map"
              class="mr-1"
            />
            <span v-if="event.location_ref">{{ event.location_ref.name }}</span>
            <span v-else>{{ event.location }}</span>
          </p>
          <div>
            <h6>
              <b-badge
                v-for="item in event.tags"
                :key="item.id"
                class="mr-2 pink"
              >
                {{ item.title }}
              </b-badge>
            </h6>
          </div>
        </div>
      </b-link>
    </article>
  </b-col>
</template>

<script>
import {getDate, getImage} from "@/helpers";

export default {
  name: 'EventCard',
  props: {
    event: {
      type: Object,
    },
    colSize: {
      type: String,
    }
  },
  methods: {
    getDate, getImage,
  }
}
</script>

<style lang="less" scoped>
.card {
  color: #333;
  display: flex;
  height: 100%;
  transition: .4s all;

  &:hover {
    border-color: transparent;
    box-shadow: 0 0 6px #d5347a;
  }

  a {
    color: #232323;
  }

  .card-body {
    position: relative;
    padding: 1.5rem 1.25rem;
    max-height: 210px;
  }

  .card-title {
    max-height: 48px;
    overflow: hidden;
  }

  &:hover {
    color: #333;
  }

  .date {
    font-size: 0.8rem;
    position: absolute;
    top: 2px;
    right: 5px;
  }

  .address {
    font-size: 0.75rem;
    max-height: 36px;
  }

  .tags {
    max-height: 40px;
  }
}

.draft-badge {
  top: 16px;
  left: 18px;
}
</style>
